/* eslint-disable no-unused-vars */
import React from 'react';
import style from './indicator.module.scss';

export default function RequestItem({ bgColor }: { bgColor?: string }) {
  return (
    <div style={{ background: bgColor }} className={style.container}></div>
  );
}
